import React from 'react'
import {Box, BoxProps, Flex, HStack, Text} from '@chakra-ui/react'
import {isString} from 'lodash-es'
import PriceText from '_app/components/PriceText'
import {CustomizableEngraveOption, Maybe, Money, SelectedCustomizableOption} from '_app/graphql/generated/graphql'
import {RenderEngvValue} from './RenderEngvValue'
import {CustomizableEngraveCartItem} from './PaidOptions'

interface EngravingOptionsProps extends BoxProps {
    options: Maybe<SelectedCustomizableOption>[];
    customizableEngravingOptions: Maybe<CustomizableEngraveOption>[];
    isShowEngravingTitle?: boolean;
    cartItem: CustomizableEngraveCartItem;
    isDrawerMode?: boolean;
}

export const EngravingOptions = ({
        options,
        customizableEngravingOptions,
        isShowEngravingTitle = true,
        isDrawerMode = false,
    }: EngravingOptionsProps) => {
    return (
        <Box>
            {options.map(option => {
                return option?.values?.map((value, i) => {
                    const optionDetails = customizableEngravingOptions?.filter(
                        option =>
                            option?.value?.uid === value?.customizable_option_value_uid
                    )?.[0]
                    const engvCode = optionDetails?.value?.code
                    const engvTitle = optionDetails?.title
                    const engvValue = value?.value
                    const engvPrice = value?.price
                    if (!engvCode) return
                    return (
                        <HStack
                            key={i}
                            spacing="1.875rem"
                            justifyContent="space-between"
                            alignItems="flex-start"
                            sx={{
                                marginTop: isShowEngravingTitle && '0.5rem',
                                '&:not(:last-child)': {
                                    paddingBottom: 2,
                                    borderBottom: 'solid 1px',
                                    borderColor: 'borderLight',
                                    width: '100%',
                                },
                            }}
                            width="100%"
                            pr={{
                                base: 0,
                                lg: isDrawerMode ? 0 : '4.5rem',
                            }}
                        >
                            <Flex flexWrap="wrap">
                                {isShowEngravingTitle && (
                                    <Text textStyle="bodyLight" mr="0.625rem">
                                        <Text className="truncate-text">
                                            {engvTitle}:
                                        </Text>
                                    </Text>
                                )}
                                <Box sx={{textStyle: isShowEngravingTitle && 'body'}}>
                                    {isString(engvCode) && isString(engvValue) && (
                                        <RenderEngvValue code={engvCode} value={engvValue}/>
                                    )}
                                </Box>
                            </Flex>
                            <Box
                                sx={{
                                    paddingTop: isShowEngravingTitle ? '0.25rem' : 0,
                                }}
                                display="flex"
                                flexDirection="row"
                                gap={2}
                            >
                                <PriceText
                                    amount={
                                        {
                                            value: engvPrice?.value || 0,
                                            currency: undefined,
                                        } as Money
                                    }
                                    floating
                                    minimumFractionDigits={2}
                                />
                            </Box>
                        </HStack>
                    )
                })
            })}
        </Box>
    )
}
